/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_AlreadyInputs */

const en_invite_x15_already = /** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invitation has already been accepted.`)
};

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const ar_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const he_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const ur_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const es_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const fr_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const de_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const pt_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const hi_invite_x15_already = en_invite_x15_already;

/** @type {(inputs: Invite_X15_AlreadyInputs) => LocalizedString} */
const bn_invite_x15_already = en_invite_x15_already;

/**
* | output |
* | --- |
* | "This invitation has already been accepted." |
*
* @param {Invite_X15_AlreadyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_already = /** @type {((inputs?: Invite_X15_AlreadyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_AlreadyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_already(inputs)
	if (locale === "he") return he_invite_x15_already(inputs)
	if (locale === "ur") return ur_invite_x15_already(inputs)
	if (locale === "es") return es_invite_x15_already(inputs)
	if (locale === "fr") return fr_invite_x15_already(inputs)
	if (locale === "de") return de_invite_x15_already(inputs)
	if (locale === "pt") return pt_invite_x15_already(inputs)
	if (locale === "hi") return hi_invite_x15_already(inputs)
	if (locale === "bn") return bn_invite_x15_already(inputs)
	return /** @type {LocalizedString} */ ("This invitation has already been accepted.")
});